import type { ChartValidationResult } from './chartValidation.types'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/** Decode the bare 200/422 validation body without coupling the model to HTTP infrastructure. */
export function parseChartValidationResult(value: unknown): ChartValidationResult {
  if (!isRecord(value) || typeof value.valid !== 'boolean') {
    throw new TypeError('Malformed chart validation response')
  }
  const errors = Array.isArray(value.errors)
    ? value.errors.filter((item): item is string => typeof item === 'string')
    : []
  const warnings = Array.isArray(value.warnings)
    ? value.warnings.filter((item): item is string => typeof item === 'string')
    : []
  return { valid: value.valid, errors, warnings }
}
